<div class="text-clamp">
  <div class="line-clamp-{{ lines }}">
    <ng-content></ng-content>
  </div>
</div>
